<template>
  <div class="home">
    <b-modal
      size="sm"
      cancel-only
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      id="upload-files"
      title="アップロード中です"
      hide-footer
    >
    </b-modal>
    <div v-if="saved" class="alert alert-primary" role="alert">
      保存しました。
    </div>
    <div v-if="deleted" class="alert alert-danger" role="alert">
      削除しました。
    </div>
    <b-modal
      size="xl"
      id="form-modal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      v-bind:title="
        !selectedTrainer.id
          ? '新規作成'
          : '「' + selectedTrainer.name + '」を編集'
      "
      hide-footer
    >
      <div v-if="thumbnailFileProgressMessage || iconFileProgressMessage">
        <p>
          イメージ画像：{{
            thumbnailFileProgressMessage
              ? thumbnailFileProgressMessage
              : "変更なし"
          }}
        </p>
        <p>
          アイコン:{{
            iconFileProgressMessage ? iconProgressMessage : "変更なし"
          }}
        </p>
        <div class="text-right">
          <button
            class="btn btn-sm btn-outline-secondary col-5"
            @click="cancelSaving()"
          >
            キャンセル
          </button>
        </div>
      </div>
      <div v-else>
        <b-form @submit.prevent="saveTrainer">
          <b-form-group class="form-group">
            <div class="input-group text-center">
              <div class="mr-2 col-3 text-right">名前</div>
              <input
                type="text"
                class="form-control col-9 mt-1"
                required="required"
                v-model.trim="selectedTrainer.name"
                placeholder="名前"
                @keydown.self.prevent.enter
              />
            </div>
            <div class="input-group text-center">
              <div class="mr-2 col-3 text-right">肩書き</div>
              <input
                type="text"
                class="form-control col-9 mt-1"
                required="required"
                v-model.trim="selectedTrainer.title"
                placeholder="水泳,柔道など"
                @keydown.self.prevent.enter
              />
            </div>
            <div class="input-group text-center mt-4">
              <div class="mr-2 col-3 text-right">bio:</div>
              <b-form-textarea
                id="textarea"
                required="required"
                v-model.trim="selectedTrainer.bio"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
                class="col-9 mt-1"
              ></b-form-textarea>
            </div>
            <div
              class="input-group text-center mt-4"
              v-if="selectedTrainer.params"
            >
              <div class="mr-2 col-3 text-right">
                1日のパラメータ:<br /><small>(0-1000)</small><br /><small
                  >※全てゼロか空で無効</small
                >
              </div>
              <b-col cols="8">
                <b-row>
                  <b-input-group
                    size="sm"
                    v-for="(param, paramKey) in paramsDefinitions"
                    :key="paramKey"
                    class="col-4 p-0"
                  >
                    <b-input-group-prepend>
                      <b-input-group-text class="text-right rounded-0">{{
                        param.ja.padStart(2, "\u3000")
                      }}</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model.number="selectedTrainer.params[param.id]"
                      class="text-right rounded-0"
                      type="number"
                      min="0"
                      max="1000"
                      step="1"
                    ></b-form-input>
                  </b-input-group>
                </b-row>
              </b-col>
            </div>
            <div class="input-group text-center mt-4">
              <div class="mr-2 col-3 text-right">Instagram:</div>
              <input
                type="url"
                class="form-control col-9 mt-1"
                v-model="selectedTrainer.instagram"
                placeholder="https://...からはじまるインスタページ"
                @keydown.self.prevent.enter
              />
            </div>
            <div class="input-group text-center mt-4">
              <div class="mr-2 col-3 text-right">Twitter:</div>
              <input
                type="url"
                class="form-control col-9 mt-1"
                v-model="selectedTrainer.twitter"
                placeholder="https://...からはじまるTwitterアカウント"
                @keydown.self.prevent.enter
              />
            </div>
            <div class="input-group text-center mt-4">
              <div class="mr-2 col-3 text-right">YouTube:</div>
              <input
                type="url"
                class="form-control col-9 mt-1"
                v-model="selectedTrainer.youtube"
                placeholder="https://...からはじまるチャンネルURL"
                @keydown.self.prevent.enter
              />
            </div>
            <div class="input-group text-center mt-4">
              <div class="mr-2 col-3 text-right">Facebook:</div>
              <input
                type="url"
                class="form-control col-9 mt-1"
                v-model="selectedTrainer.facebook"
                placeholder="https://...からはじまるFBページ"
                @keydown.self.prevent.enter
              />
            </div>

            <div
              v-if="selectedTrainer.thumbnailFileName"
              class="col-12 text-center mt-4 text-center"
            >
              <strong
                >以下はイメージを差し替えるときのみアップロードしてください。</strong
              >
            </div>

            <div class="input-group text-center mt-4">
              <div class="col-3 text-right mt-2">アイコン画像：</div>
              <div class="col-9 px-2">
                <b-form-file
                  v-model="selectedTrainer.iconFile"
                  :state="Boolean(selectedTrainer.iconFile)"
                  accept=".webp, .jpg, .jpeg, .png, .gif"
                  placeholder="webp,jpeg,png,gifを選択かドロップ"
                  drop-placeholder="Drop file here..."
                  :required="selectedTrainer.id == ''"
                ></b-form-file>
                ※256x256px以上の1:1。背景は透明も可。表示は丸型になります。
              </div>
            </div>
            <div class="input-group text-center mt-4">
              <div class="col-3 text-right mt-2">イメージ画像：</div>
              <div class="col-9 px-2">
                <b-form-file
                  v-model="selectedTrainer.thumbnailFile"
                  :state="Boolean(selectedTrainer.thumbnailFile)"
                  accept=".webp, .jpg, .jpeg, .png, .gif"
                  placeholder="webp,jpeg,png,gifを選択かドロップ"
                  drop-placeholder="Drop file here..."
                  :required="selectedTrainer.id == ''"
                ></b-form-file>
                ※768x432pxのみ。splitエラーが出たときはwebページを更新してください。
              </div>
            </div>
          </b-form-group>

          <div class="input-group row mt-2 mb-3">
            <button class="btn btn-sm btn-primary offset-7 col-2" type="submit">
              保存
            </button>
            <a
              class="btn btn-sm btn-outline-secondary offset-1 col-2"
              @click="$bvModal.hide('form-modal')"
            >
              キャンセル
            </a>
          </div>
        </b-form>
        <div
          v-if="confirmMessage"
          class="alert alert-info"
          role="alert"
          style="white-space: pre-wrap; word-wrap: break-word"
        >
          {{ confirmMessage.trim() }}
        </div>
      </div>
    </b-modal>
    <div class="pt-3">
      <b-form inline>
        <label class="ml-auto">絞り込み:</label>
        <b-form-select
          id="offset-option"
          :options="offsetOptions"
          v-model="offsetOption"
          class="m-md-2 col-2"
          variant="outline-secondary"
          @change="searchTimeOut()"
        >
        </b-form-select>
        <b-form-select
          :options="sortOrderOptions"
          v-model="sortOrderOption"
          class="m-md-2 col-3"
          variant="outline-secondary"
          @change="searchTimeOut(true)"
        >
        </b-form-select>
        <b-form-input
          type="text"
          class="m-md-2 col-3"
          placeholder="フリーワード(bio含む)"
          variant="outline-secondary"
          v-model="keyword"
          @keyup="searchTimeOut()"
          @keydown.self.prevent.enter
        ></b-form-input
      ></b-form>
    </div>
    <div class="text-right p-3">
      <button
        class="btn btn-primary col-3"
        @click="
          confirmMessage = null;
          newTrainer();
          $bvModal.show('form-modal');
        "
      >
        ＋新規作成
      </button>
    </div>
    <div class="text-left px-3">削除は動画数を０にしてから行えます。</div>
    <table class="table">
      <tr>
        <th class="align-middle text-center" style="width: 10%">編集</th>
        <th class="align-middle text-center" style="width: 20%">アイコン</th>
        <th class="align-middle text-center" style="width: 30%">イメージ</th>
        <th class="align-middle text-center" style="width: 40%">情報</th>
      </tr>
      <tr v-for="(item, key) in filteredTrainers()" :key="key">
        <td class="align-middle text-center">
          <div class="pt-4">
            <button class="btn btn-secondary" @click="editTrainer(item)">
              編集
            </button>
          </div>
          <div
            class="pt-3"
            v-if="
              videos.filter(
                (x) => x.trainers && x.trainers.some((g) => g.id == item.id)
              ).length == 0
            "
          >
            <button class="btn btn-danger" @click.stop.prevent="onDelete(item)">
              削除
            </button>
          </div>
          <div
            class="pt-3"
            v-if="
              videos.filter(
                (x) =>
                  x.published &&
                  x.trainers &&
                  x.trainers.some((g) => g.id == item.id)
              ).length > 0
            "
          >
            <button
              class="btn btn-success"
              @click.stop.prevent="onCreateTopic(item)"
            >
              通知<br />作成
            </button>
          </div>
        </td>
        <td class="align-middle text-center">
          <b-img
            rounded="circle"
            v-bind:src="item.iconUrl"
            style="max-height: 128px"
          />
        </td>
        <td class="align-middle text-center">
          <img v-bind:src="item.thumbnailUrl" style="max-height: 200px" />
        </td>
        <td class="align-middle">
          <small>{{ item.title }}</small>
          <h3>{{ item.name }}</h3>
          <p><small>ID: {{ item.id }}</small></p>
          <strong
            >動画数 公開：{{
              videos.filter(
                (x) =>
                  x.published &&
                  x.trainers &&
                  x.trainers.some((g) => g.id == item.id)
              ).length
            }}&nbsp;&nbsp;下書き：{{
              videos.filter(
                (x) =>
                  !x.published &&
                  x.trainers &&
                  x.trainers.some((g) => g.id == item.id)
              ).length
            }}</strong
          >
          <p style="white-space: pre-wrap">
            {{ item.bio.replaceAll("\\n", "\n") }}
          </p>
          <div v-if="item.instagram" style="white-space: pre-wrap">
            Instagram:
            <b-link :href="item.instagram">{{ item.instagram }}</b-link>
          </div>
          <div v-if="item.twitter" style="white-space: pre-wrap">
            Twitter: <b-link :href="item.twitter">{{ item.twitter }}</b-link>
          </div>
          <div v-if="item.youtube" style="white-space: pre-wrap">
            YouTube: <b-link :href="item.youtube">{{ item.youtube }}</b-link>
          </div>
          <div v-if="item.facebook" style="white-space: pre-wrap">
            Facebook: <b-link :href="item.facebook">{{ item.facebook }}</b-link>
          </div>
          <div>
            <small>作成日時：{{ formatDate(item.createdAt) }}</small>
          </div>
          <div>
            <small>更新日時：{{ formatDate(item.updatedAt) }}</small>
          </div>
          <div class="text-left mt-2">1日のパラメータ：</div>
          <p v-if="item.params" class="p-2">
            <b-row>
              <b-col
                cols="4"
                class="py-2"
                v-for="(param, key4) in paramsDefinitions"
                :key="key4"
              >
                <b-row class="px-0 mx-0">
                  <b-col cols="8" class="text-right p-0">
                    <small>{{ param.ja.padStart(2, "\u3000") }}: </small>
                  </b-col>
                  <b-col cols="4" class="text-right p-0">
                    <small>{{ item.params[param.id].toString() }}</small>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </p>
          <p v-else>
            <small>未設定</small>
          </p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import firebase from "firebase";
import "firebase/firestore";
import "firebase/storage";
import { getParamsDefinitions } from "../getParamsDefinitions";
import { getVideos } from "../getVideos";

import Vue from "vue";
import VueHolder from "vue-holderjs";
Vue.use(VueHolder);

export default {
  name: "Trainer",
  data: function() {
    return {
      trainer: {
        id: "",
        name: "",
        bio: "",
        title: "",
        thumbnailFileName: null,
        thumbnailUrl: null,
        thumbnailFile: null,
        iconFileName: null,
        iconUrl: null,
        iconFile: null,
        facebook: null,
        youtube: null,
        instagram: null,
        twitter: null
      },
      offsetOption: "10",
      offsetOptions: [
        { value: "10", text: "10件" },
        { value: "30", text: "30件" },
        { value: "50", text: "50件" }
      ],
      sortOrderOption: "name,asc",
      sortOrderOptions: [
        { value: "updatedAt,desc", text: "最新更新順" },
        { value: "createdAt,desc", text: "最新作成順" },
        { value: "name,asc", text: "名前昇順" },
        { value: "name,desc", text: "名前降順" }
      ],
      videos: [],
      selectedTrainer: {},
      trainers: [],
      errors: [],
      saved: false,
      deleted: false,
      keyword: "",
      editFlg: false,
      confirmMessage: null,
      thumbnailFileProgressMessage: null,
      thumbnailUploadTask: null,
      iconFileProgressMessage: null,
      iconUploadTask: null,
      paramsDefinitions: [],
      timer: null,
      needReLoad: false
    };
  },
  mounted: async function() {
    this.paramsDefinitions = await getParamsDefinitions();
    this.videos = await getVideos();
    this.getFromUrlParams();
    this.getTrainers();
  },
  methods: {
    isEmptyOrSpaces: function(str) {
      return !str || str.match(/^ *$/) !== null;
    },
    isEmptyParams: function(params) {
      if (!params) {
        return true;
      }
      let total = 0;
      Object.keys(params).forEach(key => {
        total += params[key] ? params[key] : 0;
      });
      return total == 0;
    },
    //trainer
    newTrainer: function() {
      this.saved = false;
      this.deleted = false;
      this.selectedTrainer = {};
      this.selectedTrainer.params = {};
      this.paramsDefinitions.forEach(item => {
        this.selectedTrainer.params[item.id] = 0;
      });
    },
    editTrainer: function(trainer) {
      this.saved = false;
      this.deleted = false;
      this.selectedTrainer = {
        id: trainer.id,
        name: trainer.name,
        title: trainer.title,
        bio: trainer.bio.replaceAll("\\n", "\n"),
        params: trainer.params,
        thumbnailUrl: trainer.thumbnailUrl,
        thumbnailFileName: trainer.thumbnailFileName,
        thumbnailFile: null,
        iconUrl: trainer.iconUrl,
        iconFileName: trainer.iconFileName,
        iconFile: null,
        facebook: trainer.facebook,
        youtube: trainer.youtube,
        instagram: trainer.instagram,
        twitter: trainer.twitter
      };
      if (!this.selectedTrainer.params) {
        this.selectedTrainer.params = {};
        this.paramsDefinitions.forEach(item => {
          this.selectedTrainer.params[item.id] = 0;
        });
      }
      this.$bvModal.show("form-modal");
    },
    storeTrainer: async function(trainer) {
      let data = this;
      return new Promise(function(resolve, reject) {
        if (data.selectedTrainer.id) {
          firebase
            .firestore()
            .collection("trainers")
            .doc(data.selectedTrainer.id)
            .update(trainer)
            .then(function() {
              data.saved = true;
              resolve();
            })
            .catch(function(error) {
              reject("保存でエラーが発生しました:" + error);
            });
        } else {
          firebase
            .firestore()
            .collection("trainers")
            .add(trainer)
            .then(function() {
              data.saved = true;
              resolve();
            })
            .catch(function(error) {
              reject("保存でエラーが発生しました:" + error);
            });
        }
      });
    },
    putStorageThumbnail: function(trainer) {
      let data = this;
      return new Promise(function(resolve, reject) {
        const storageRef = firebase.storage().ref();
        data.thumbnailUploadTask = storageRef
          .child(trainer.thumbnailFileName)
          .put(
            data.selectedTrainer.thumbnailFile,
            data.selectedTrainer.thumbnailFile.type
          );

        data.thumbnailUploadTask.on(
          firebase.storage.TaskEvent.STATE_CHANGED,
          function(snapshot) {
            data.thumbnailFileProgressMessage =
              (
                (snapshot.bytesTransferred / snapshot.totalBytes) *
                100
              ).toString() + "%";
          },
          function(error) {
            switch (error.code) {
              case "storage/canceled":
                break;
              default:
                alert(
                  "イメージアップロード中にクラウドストレージにおけるその他のエラーが発生しました。:" +
                    error.code
                );
                break;
            }
            reject();
          },
          function() {
            data.thumbnailUploadTask.snapshot.ref
              .getDownloadURL()
              .then(function(downloadURL) {
                resolve(downloadURL);
              });
          }
        );
      });
    },
    putStorageIcon: function(trainer) {
      let data = this;
      return new Promise(function(resolve, reject) {
        const storageRef = firebase.storage().ref();
        data.iconUploadTask = storageRef
          .child(trainer.iconFileName)
          .put(
            data.selectedTrainer.iconFile,
            data.selectedTrainer.iconFile.type
          );

        data.iconUploadTask.on(
          firebase.storage.TaskEvent.STATE_CHANGED,
          function(snapshot) {
            data.iconFileProgressMessage =
              (
                (snapshot.bytesTransferred / snapshot.totalBytes) *
                100
              ).toString() + "%";
          },
          function(error) {
            switch (error.code) {
              case "storage/canceled":
                break;
              default:
                alert(
                  "イメージアップロード中にクラウドストレージにおけるその他のエラーが発生しました。:" +
                    error.code
                );
                break;
            }
            reject();
          },
          function() {
            data.iconUploadTask.snapshot.ref
              .getDownloadURL()
              .then(function(downloadURL) {
                resolve(downloadURL);
              });
          }
        );
      });
    },
    saveTrainer: async function() {
      this.thumbnailFileProgressMessage = null;
      this.iconlFileProgressMessage = null;

      this.paramsDefinitions.forEach(item => {
        //空文字等あるので潰す
        this.selectedTrainer.params[item.id] = Number(
          this.selectedTrainer.params[item.id]
        );
      });
      if (this.selectedTrainer.id) {
        this.updateTrainer();
      } else {
        this.createTrainer();
      }
    },
    createTrainer: async function() {
      let data = this;
      let trainer = {
        name: data.selectedTrainer.name,
        bio: data.selectedTrainer.bio,
        title: data.selectedTrainer.title,
        thumbnailFileName: "trainers/" + data.getHash(64),
        iconFileName: "trainers/" + data.getHash(64),
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        facebook: data.isEmptyOrSpaces(data.selectedTrainer.facebook)
          ? null
          : data.selectedTrainer.facebook,
        youtube: data.isEmptyOrSpaces(data.selectedTrainer.youtube)
          ? null
          : data.selectedTrainer.youtube,
        instagram: data.isEmptyOrSpaces(data.selectedTrainer.instagram)
          ? null
          : data.selectedTrainer.instagram,
        twitter: data.isEmptyOrSpaces(data.selectedTrainer.twitter)
          ? null
          : data.selectedTrainer.twitter
      };
      if (!this.isEmptyParams(data.selectedTrainer.params)) {
        trainer.params = data.selectedTrainer.params;
      }
      try {
        trainer.thumbnailUrl = await this.putStorageThumbnail(trainer);
        trainer.iconUrl = await this.putStorageIcon(trainer);
        this.thumbnailFileProgressMessage = null;
        this.iconFileProgressMessage = null;
        await this.storeTrainer(trainer);
        this.$bvModal.hide("form-modal");
        this.getTrainers();
      } catch (err) {
        this.thumbnailFileProgressMessage = null;
        this.iconFileProgressMessage = null;
        alert("エラーが発生しました:" + err);
      }
    },
    updateTrainer: async function() {
      let data = this;
      let trainer = {
        name: data.selectedTrainer.name,
        bio: data.selectedTrainer.bio,
        title: data.selectedTrainer.title,
        params: firebase.firestore.FieldValue.delete(),
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        thumbnailFileName: data.selectedTrainer.thumbnailFileName,
        iconFileName: data.selectedTrainer.iconFileName,
        facebook: data.isEmptyOrSpaces(data.selectedTrainer.facebook)
          ? null
          : data.selectedTrainer.facebook,
        youtube: data.isEmptyOrSpaces(data.selectedTrainer.youtube)
          ? null
          : data.selectedTrainer.youtube,
        instagram: data.isEmptyOrSpaces(data.selectedTrainer.instagram)
          ? null
          : data.selectedTrainer.instagram,
        twitter: data.isEmptyOrSpaces(data.selectedTrainer.twitter)
          ? null
          : data.selectedTrainer.twitter
      };
      if (!this.isEmptyParams(data.selectedTrainer.params)) {
        trainer.params = data.selectedTrainer.params;
      }
      try {
        if (data.selectedTrainer.thumbnailFile) {
          trainer.thumbnailUrl = await this.putStorageThumbnail(trainer);
        }
        if (data.selectedTrainer.iconFile) {
          trainer.iconUrl = await this.putStorageIcon(trainer);
        }
        this.thumbnailFileProgressMessage = null;
        this.iconFileProgressMessage = null;
        await this.storeTrainer(trainer);
        this.$bvModal.hide("form-modal");
        this.getTrainers();
      } catch (err) {
        this.thumbnailFileProgressMessage = null;
        this.iconFileProgressMessage = null;
        alert("もう一度ご送信ください エラー:" + err);
      }
    },
    onDelete: function(trainer) {
      this.saved = false;
      this.deleted = false;
      let data = this;
      this.$bvModal
        .msgBoxConfirm(
          "「" +
            trainer.name +
            "」を削除します。この操作はやり直せません。削除しますか？"
        )
        .then(result => {
          if (!result) {
            return;
          }
          firebase
            .firestore()
            .collection("trainers")
            .doc(trainer.id)
            .delete()
            .then(function() {
              data.deleted = true;
              data.getTrainers();
            })
            .catch(function(error) {
              console.error(error);
              alert("削除エラー: ", error);
            });
        });
    },
    onCreateTopic: function(trainer) {
      this.$router.push({ path: "/Topic", query: { trainer: trainer.id } });
    },
    cancelSaving: function() {
      if (this.thumbnailUploadTask != null) {
        this.thumbnailUploadTask.cancel();
      }
      if (this.iconUploadTask != null) {
        this.iconUploadTask.cancel();
      }
      this.$bvModal.hide("upload-files");
    },
    filteredTrainers: function() {
      let data = this;
      if (!this.keyword) {
        return this.trainers.slice(0, Number(this.offsetOption));
      }
      const res = [];
      this.trainers.forEach(function(trainer) {
        if (
          trainer.name.toLowerCase().includes(data.keyword.toLowerCase()) ||
          (trainer.title &&
            trainer.title.toLowerCase().includes(data.keyword.toLowerCase())) ||
          trainer.bio.toLowerCase().includes(data.keyword.toLowerCase())
        ) {
          res.push(trainer);
        }
      });
      return res.slice(0, Number(this.offsetOption));
    },
    getTrainers: function() {
      let self = this;
      const ref = firebase.firestore().collection("trainers");
      const query = ref;
      query
        .orderBy(
          this.sortOrderOption.split(",")[0],
          this.sortOrderOption.split(",")[1]
        )
        .get()
        .then(function(querySnapshot) {
          let datas = [];
          querySnapshot.forEach(function(doc) {
            let d = doc.data();
            d.id = doc.id;
            datas.push(d);
          });
          self.trainers = datas;
        })
        .catch(function(error) {
          console.error("Error getting documents: ", error);
        });
    },
    getFromUrlParams: function() {
      if (this.$route.query["c"]) {
        this.offsetOption = this.$route.query["c"];
      }

      if (this.$route.query["o"]) {
        this.sortOrderOption = this.$route.query["o"];
      }

      if (this.$route.query["kw"]) {
        this.keyword = this.$route.query["kw"];
      }
    },
    routerPush() {
      let pushRouteParam = {
        c: this.offsetOption,
        o: this.sortOrderOption,
        kw: this.keyword
      };
      this.$router.push({ path: "", query: pushRouteParam });
    },
    searchTimeOut(needReLoad) {
      this.needReLoad = needReLoad;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.routerPush();
      }, 1000);
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (this.needReLoad) {
      this.needReLoad = false;
      this.getTrainers();
    }
    this.saved = false;
    this.deleted = false;
    next();
  }
};
</script>
